// import "./App.css";
// import { BrowserRouter } from "react-router-dom";
// import React, { Suspense } from "react";
// import AuthProvider from "./Context/AuthProvider";
// import { Box, CssBaseline, ThemeProvider } from "@mui/material";
// import loading from "./Components/Vendors/Images/loading.gif";
// import theme from "./theme.js";
// const Routing = React.lazy(() => import("./Components/Routing/Routing.js"));

// function App() {
//   return (
//     <div className="app-container">
//       <ThemeProvider theme={theme}>
//         <CssBaseline />
//         <AuthProvider>
//           <Suspense
//             fallback={
//               <Box
//                 sx={{
//                   height: "100vh",
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   flexDirection: "column",
//                 }}
//               >

//                 <img
//                   src={loading}
//                   alt="loading"
//                   style={{
//                     width: "200px",
//                     height: "200px",
//                   }}
//                 />
//               </Box>
//             }
//           >
//             <BrowserRouter>
//               <Routing />
//             </BrowserRouter>
//           </Suspense>
//         </AuthProvider>
//       </ThemeProvider>
//     </div>
//   );
// }

// export default App;

import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./Context/AuthProvider";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import loading from "./Components/Vendors/Images/loading.gif";
import theme from "./theme.js";
const Routing = React.lazy(() => import("./Components/Routing/Routing.js"));

function App() {
  return (
    <div className="app-container">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Suspense
            fallback={
              <Box
                sx={{
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src={loading}
                  alt="loading"
                  style={{ width: "200px", height: "200px" }}
                />
              </Box>
            }
          >
            <BrowserRouter>
              <Routing />
            </BrowserRouter>
          </Suspense>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
